<template>
  <Funded>
  </Funded>
</template>

<script>
import Funded from "../components/Funded.vue";
export default {
  name: "Portofolio",
  components: {
    Funded
  },
}
</script>
